/* InsightsFilterDto.ts */

/* Constants */
import { Insights } from "src/shared/constants/common/Common";

/* Interfaces */
import { BaseInsightsFilterResponse } from "src/shared/interfaces/api/InsightsFilters";

export class InsightsFilterResponseDto
  implements BaseInsightsFilterResponse
{
  public features: string[];
  public cohorts: string[];
  public firstYear: any;
  public lastYear: any;

  constructor(data: any) {
    // Feature ordering (treatment features / treatment-line features pushed to
    // the end) is done once in the backend `order_feature_options`, so the list
    // arrives already ordered - see insights/backend options.py.
    this.features = data.features;
    this.cohorts = (data.cohorts ?? []).map(
      (item: string) =>
        item === "" ? Insights.FULL_SAMPLE : item
    );

    this.firstYear = new Date(
      data.first_year
    ).getFullYear();

    this.lastYear = new Date(data.last_year).getFullYear();
  }

  static fromApi(
    data: BaseInsightsFilterResponse
  ): InsightsFilterResponseDto {
    return new InsightsFilterResponseDto(data);
  }

  toObject(): BaseInsightsFilterResponse {
    return {
      features: this.features,
      cohorts: this.cohorts,
      firstYear: this.firstYear.toString(),
      lastYear: this.lastYear.toString(),
    };
  }
}
